import { render } from "./product1.vue?vue&type=template&id=e6a4f2be"
import script from "./product1.vue?vue&type=script&lang=js"
export * from "./product1.vue?vue&type=script&lang=js"

import "./product1.vue?vue&type=style&index=0&id=e6a4f2be&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__